<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateSensor"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.general_information')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @fillSensorForm="fillSensorForm"
              @showHideLoading="showHideLoading"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('common_words.ubication')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              @on-validated="onStepValidated"
              @fillSensorForm="fillSensorForm"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content
            :title="$t('common_words.association')"
            :before-change="() => validateStep('thirdStep')"
          >
            <third-step
              ref="thirdStep"
              @on-validated="onStepValidated"
              @fillSensorForm="fillSensorForm"
              @showHideLoading="showHideLoading"
            ></third-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <p
              class="cm-mg-p-wzd text-center text-muted"
            >4.1 {{ $t('common_words.verify_inputed_information') }}</p>
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-9">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td :style="'background-color: ' + sensorForm.color">
                        <h6>
                          <strong>{{ $t('common_words.color') }}:</strong>
                        </h6>
                        {{ sensorForm.color }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.name') }}:</strong>
                        </h6>
                        {{ sensorForm.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.description') }}:</strong>
                        </h6>
                        {{ sensorForm.two_name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.code') }}:</strong>
                        </h6>
                        {{ sensorForm.code }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('labor.unit') }}:</strong>
                        </h6>
                        {{ sensorForm.unit }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>¿{{ $t('devices.calculated') }}?:</strong>
                        </h6>
                        {{
                        sensorForm.calculated === 0
                        ? $t('common_words.mayus_no')
                        : $t('common_words.mayus_yes')
                        }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>¿{{ $t('devices.probe_belongs') }}?:</strong>
                        </h6>
                        {{
                        sensorForm.is_probe === 0
                        ? $t('common_words.mayus_no')
                        : $t('common_words.mayus_yes')
                        }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.values') }}:</strong>
                        </h6>
                        {{ sensorForm.field.join(', ') }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.grouping_number') }}:</strong>
                        </h6>
                        {{ sensorForm.grouping_number }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.type_graph') }}:</strong>
                        </h6>
                        {{ graphsSelections[sensorForm.type_graph] }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong>
                            {{
                            $t('devices.associated_stations_parenthesis')
                            }}:
                          </strong>
                        </h6>
                        <span
                          v-for="(station, index) in sensorForm.names_stations"
                          :key="`st-${index}`"
                        >
                          <el-tag type="info">{{ station }}</el-tag>
                        </span>
                        <el-tag
                          type="warning"
                          v-if="sensorForm.names_stations.length == 0"
                        >{{ $t('devices.no_associated_stations') }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong>
                            {{
                            $t('common_words.associated_companies')
                            }}:
                          </strong>
                        </h6>
                        <span
                          v-for="(business, index) in sensorForm.names_business"
                          :key="`bn-${index}`"
                        >
                          <el-tag type="info">{{ business }}</el-tag>
                        </span>
                        <el-tag type="warning" v-if="sensorForm.names_business.length == 0">
                          {{
                          $t('common_words.no_associated_companies')
                          }}
                        </el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong>{{ $t('common_words.associated_farms') }}:</strong>
                        </h6>
                        <span v-for="(farm, index) in sensorForm.names_farms" :key="`fr-${index}`">
                          <el-tag type="info">{{ farm }}</el-tag>
                        </span>
                        <el-tag
                          type="warning"
                          v-if="sensorForm.names_farms.length == 0"
                        >{{ $t('common_words.no_associated_farms') }}</el-tag>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-9">
                <div ref="map" class="map" v-if="renderComponent" style="height: 500px"></div>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">{{ $t('common_words.no_permissions_operations') }}</h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import FirstStep from './steps/FirstStep.vue';
import SecondStep from './steps/SecondStep.vue';
import ThirdStep from './steps/ThirdStep.vue';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import { Axios } from 'src/class/Axios.js';
import mixinMasters from 'src/util/mixinMasters';
import { showContinue } from 'src/util/Util.js';
import MixinMenu from 'src/util/mixinMenu';

export default {
  components: {
    FirstStep,
    SecondStep,
    ThirdStep
  },

  data() {
    return {
      center: {
        lat: 10.8906,
        lng: -74.18756
      },
      title: '',
      sensorForm: {
        names_business: [],
        names_farms: [],
        names_stations: [],
        field: []
      },
      wizardModel: {},
      map: null,
      renderComponent: true,
      graphsSelections: {
        spline: 'Línea de Curva',
        column: 'Columnas',
        areaspline: 'Línea de Área',
        line: 'Línea',
        scatter: 'Dispersión',
        arearange: 'Rango Área'
      }
    };
  },

  mixins: [MixinPermissions, MixinArcgisMap, mixinMasters, MixinMenu],

  methods: {
    cleanAllSteps() {
      this.$refs.firstStep.model = {
        name: null,
        code: null,
        two_name: null,
        unit: null,
        color: null,
        field: []
      };
      this.$refs.secondStep.model = {};
      this.$refs.thirdStep.model = {};
      this.sensorForm = {
        names_business: [],
        names_farms: [],
        names_stations: [],
        field: []
      };
    },

    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },

    fillSensorForm(ref, others) {
      this.sensorForm = Object.assign(
        {},
        this.sensorForm,
        this.$refs[ref].model
      );

      if (others) this.sensorForm = Object.assign({}, this.sensorForm, others);

      this.center.lat = this.sensorForm.latitude
        ? parseFloat(this.sensorForm.latitude)
        : this.center.lat;
      this.center.lng = this.sensorForm.longitude
        ? parseFloat(this.sensorForm.longitude)
        : this.center.lng;

      this.loadMap();
    },

    storeUpdateSensor() {
      this.showHideLoading(true);
      this.sensorForm.route = 'devices/sensors';
      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.sensorForm.id = JSON.parse(
            sessionStorage.getItem('editForm')
          ).id;
          Axios.updateMaster(this.sensorForm)
            .then(response => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/devices/sensors',
                null
              );
            })
            .catch(error => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.sensorForm)
            .then(response => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/devices/sensors',
                null
              );
            })
            .catch(error => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },

    loadMap() {
      this.renderComponent = false;

      this.$nextTick(() => {
        this.renderComponent = true;
        this.loadBaseMap(null);
      });
    }
  },

  mounted() {
    this.selectedItemOnMenu('devices');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('devices');
  }
};
</script>
<style></style>
